import { Card, SxProps, Theme, useTheme } from "@mui/material";

type BasicCardProps = {
  children: React.ReactNode;
  onClick?: () => void;
  sx?: SxProps<Theme>;
};

export const BasicCard = ({ children, onClick, sx }: BasicCardProps) => {
  const theme = useTheme();

  return (
    <Card
      onClick={onClick}
      sx={{
        backgroundColor:
          theme.palette.mode === "dark" ? theme.palette.grey[800] : "#fcfcfc",
        ...sx,
      }}
    >
      {children}
    </Card>
  );
};
